import * as React from "react";
import PropTypes from "prop-types";
import { Box, ButtonBase, Typography } from "@material-ui/core";
import { styled } from "@material-ui/core/styles";
import clsx from "clsx";
import { Influencer } from "../../domain";
import { Skeleton } from "@material-ui/lab";

const ImageAvatar = React.memo(function ImageAvatar({
  influencer,
  height = 300,
  width = 220,
  disableShadow,
  onClick,
}) {
  return (
    <Wrapper>
      {!influencer && <Skeleton height={height} width={width} />}

      {Boolean(influencer) && influencer.avatarUrl && onClick && (
        <StyledButtonBase
          onClick={onClick}
          aria-label={`Edit photo for ${influencer.name}`}
        >
          <StyledImage
            height={height}
            width={width}
            src={influencer.avatarUrl}
            alt={influencer.name}
            className={clsx(disableShadow && "noShadow", "pointer")}
          />
        </StyledButtonBase>
      )}

      {Boolean(influencer) && influencer.avatarUrl && !onClick && (
        <StyledImage
          height={height}
          width={width}
          src={influencer.avatarUrl}
          alt={influencer.name}
          className={clsx(disableShadow && "noShadow")}
        />
      )}

      {Boolean(influencer) && !influencer.avatarUrl && onClick && (
        <StyledButtonBase onClick={onClick} aria-label="Add a shop image">
          <StyledBox
            width={width}
            height={height}
            display="flex"
            justifyContent="center"
            alignItems="center"
            p={1}
          >
            <Typography align="center" color="textSecondary" variant="caption">
              Add a Shop Image
            </Typography>
          </StyledBox>
        </StyledButtonBase>
      )}

      {Boolean(influencer) && !influencer.avatarUrl && !onClick && (
        <StyledBox
          width={width}
          height={height}
          display="flex"
          justifyContent="center"
          alignItems="center"
          p={1}
        >
          <Typography align="center" color="textSecondary" variant="caption">
            Add a Shop Image
          </Typography>
        </StyledBox>
      )}
    </Wrapper>
  );
});

ImageAvatar.propTypes = {
  influencer: PropTypes.instanceOf(Influencer),
  height: PropTypes.number,
  width: PropTypes.number,
  disableShadow: PropTypes.bool,
  onClick: PropTypes.func,
};

const Wrapper = styled("div")({
  display: "flex",
  justifyContent: "center",
});

const StyledButtonBase = styled(ButtonBase)(({ theme }) => ({
  borderRadius: theme.spacing(0.5),
  "&:focus-visible": {
    outline: `3px solid ${theme.palette.secondary.main}`,
    outlineOffset: 2,
  },
}));

const StyledImage = styled("img")(({ theme }) => ({
  objectFit: "cover",
  borderRadius: theme.spacing(0.5),
  boxShadow: "0px 2px 5px 0px #00000040",
  "&.noShadow": {
    boxShadow: "none",
  },
  "&.pointer": {
    cursor: "pointer",
  },
}));

const StyledBox = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.grey[300]}`,
  background: theme.palette.grey[100],
  borderRadius: theme.spacing(0.5),
}));

export default ImageAvatar;
